import { AnyRoute, createRoute } from '@tanstack/react-router'

import { z } from '@authy/lib-common/utils/zod'

import { ErrorPage } from './ErrorPage'

const errorSearchSchema = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
})

export const createErrorRoute = (parentRoute: AnyRoute) =>
    createRoute({
        getParentRoute: () => parentRoute,
        path: '/error',
        validateSearch: errorSearchSchema,
        component: ErrorPage,
    })
